import React, {forwardRef} from "react";
import {FormattedMessage} from "react-intl";
import TournamentTimer from "../TournamentTimer/TournamentTimer";
import {useSelector} from "react-redux";
import {selectLocale, selectUserCultureLg} from "../../stores/account/account.selectors";
import PrizeSlotsCounter from "../PrizeSlotsCounter/PrizeSlotsCounter";
import {useNavigate} from "react-router-dom";

import "./PreSelectedParlayCard.style.scss";
import Pick12PayoutCalculator from "../../services/Pick12ParlayPayoutCalculator";
import Pick16PayoutCalculator from "../../services/Pick16ParlayPayoutCalculator";
import {useGetRollingPrizeQuery} from "../../stores/pickX/pickX.api";
import _ from "lodash";
import moment from "moment";
import Currency from "../Currency/Currency";
import {getLeagueBySportId} from "../../utils/SportUtils";
import {PayoutModel} from "../../constants/PickXEnums";
import SportIcon from "../SportIcon/SportIcon";
import {selectPartnerById, selectPrizeAssetById} from "../../stores/pickX/pickX.selectors";

import nhlBg   from "../../../Content/images/WelcomePopUpBgs/NHL-WelcomePopup.png";
import nbaBg   from "../../../Content/images/WelcomePopUpBgs/NBA-WelcomePopup.png";
import soccerBg from "../../../Content/images/WelcomePopUpBgs/SOCCER-WelcomePopup.png";
import nflBg   from "../../../Content/images/WelcomePopUpBgs/NFL-WelcomePopup.png";
import mlbBg   from "../../../Content/images/WelcomePopUpBgs/MLB-WelcomePopup.png";
import golfBg  from "../../../Content/images/WelcomePopUpBgs/GOLF-WelcomePopup.png";

const SPORT_BG_MAP = { 1: nhlBg, 2: nbaBg, 3: soccerBg, 4: nflBg, 9: mlbBg, 12: golfBg };

const getSportBgStyle = (sportId) => {
    const bg = SPORT_BG_MAP[sportId];
    if (!bg) return {};
    return {
        backgroundImage: `linear-gradient(rgba(16, 27, 34, 0.4), rgba(16, 27, 34, 0.4)), url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    };
};


const PreSelectedParlayCard = ({parlay, asBanner}) => {

    let Component = null;
    switch(parlay.PayoutModel) {
        case PayoutModel.Pick12:
        case PayoutModel.Pick16:
            Component = PickXPreSelectedParlayCard;
            break;
        case PayoutModel.Assets:
            Component = PickXPreSelectedPrizeAssetParlayCard;
            break;
        default:
            Component = PickXPreSelectedParlayCard;
    }

    return <Component parlay={parlay}
                      asBanner={asBanner}/>;
};


const PickXPreSelectedParlayCard = ({parlay, asBanner}) => {
    const navigate = useNavigate();
    const locale = useSelector(selectLocale);
    const tr = "lobbyView.contests.prePackageContest.prePackageContestCard"
    const theCultureLg = useSelector(selectUserCultureLg)

    const handleOnClick = (parlayId) => {
        navigate('/lobby/Picks/' + parlayId);
    }

    const Calculator = parlay.ContestIds.length === 12 ? Pick12PayoutCalculator : Pick16PayoutCalculator;
    const {data:rollingPrize} = useGetRollingPrizeQuery({
        currency: parlay.FeeCurrency,
        wager: parlay.Fee,
        sportId:parlay.SportIds[0],
        payoutModel: parlay.PayoutModel
    });
    const payoutInfos = new Calculator().calculateDistribution(parlay.Fee, rollingPrize?.RollingAmount || 0.0);
    const last = _.last(payoutInfos);

    const now = moment();
    const parlayStartDate = moment(parlay.DateStart);
    const isParlayStarted = parlayStartDate.isBefore(now);
    const isPrizeAsset = parlay.PayoutModel === PayoutModel.Assets;
    const prizeAsset = useSelector(state=>selectPrizeAssetById(state, parlay.PrizeAssetId));

    return (
        <div className={`${asBanner ? "PreSelectedParlayCardBanner" : "PreSelectedParlayCard"} ${getLeagueBySportId(parlay.Name.en, parlay.SportIds[0])}`}
             style={getSportBgStyle(parlay.SportIds[0])}
             onClick={() => handleOnClick(parlay.Id)}>
            <div className="contestName">
                <SportIcon sportId={parlay.SportIds[0]}/>
                <span className="title">{parlay.Name[locale]}</span>
            </div>
            <div className="tournamentTimer">
                <TournamentTimer targetDate={new Date(parlay.DateStart)}
                                 timeOutLabel={<FormattedMessage id={"timer.closed"}/>}
                                 cultureLg={theCultureLg}/>
            </div>
            <div className="prize" >
                {!isPrizeAsset ? <PrizeSlotsCounter toAmount={last.payout}
                                                    currency={parlay.FeeCurrency}
                                                    showDecimal={last.payout < 1000}
                /> : <div className="prizeAsset name">{prizeAsset?.[`Name${locale}`]}</div>}
            </div>
            <div className="prize gold-gradient-text">
                <FormattedMessage id={`${tr}.grandPrize`} />
            </div>
            <div className="entryFee">
                <FormattedMessage id={`${tr}.entryFee`} /> <Currency currency={parlay.FeeCurrency}
                                                                     value={parlay.Fee} ></Currency>
            </div>
            <button className="playButton"><FormattedMessage id={`${tr}.${isParlayStarted ? "view" : "playNow"}`} /></button>
        </div>
    );
}
const PickXPreSelectedPrizeAssetParlayCard = ({parlay, asBanner})=>{
    const navigate = useNavigate();
    const locale = useSelector(selectLocale);
    const tr = "lobbyView.contests.prePackageContest.prePackageContestCard"
    const theCultureLg = useSelector(selectUserCultureLg)

    const handleOnClick = (parlayId) => {
        navigate('/lobby/Picks/' + parlayId);
    }
    const now = moment();
    const parlayStartDate = moment(parlay.DateStart);
    const isParlayStarted = parlayStartDate.isBefore(now);
    const prizeAsset = useSelector(state=>selectPrizeAssetById(state, parlay.PrizeAssetId));
    const name = prizeAsset[`Name${_.capitalize(locale)}`] || "";
    const partner = useSelector(state=>selectPartnerById(state, prizeAsset.PartnerId));

    return (
        <div className={`${asBanner ? "PreSelectedParlayCardBanner" : "PreSelectedParlayCard"} ${getLeagueBySportId(parlay.Name.en, parlay.SportIds[0])} prizeAsset`}
             onClick={() => handleOnClick(parlay.Id)}
        >
            <div className={"partnerBg"}
                 style={{backgroundImage: `linear-gradient(rgba(16, 27, 34, 0.8), rgba(16, 27, 34, 0.8)),url("data:image/png;base64,${partner?.Logo}")`}}>
            </div>
            <div className={"content"}>
                <div className="contestName">
                    <SportIcon sportId={parlay.SportIds[0]}/>
                    <span className="title">{parlay.Name[locale]}</span>
                </div>
                <div className="tournamentTimer">
                    <TournamentTimer targetDate={new Date(parlay.DateStart)}
                                     timeOutLabel={<FormattedMessage id={"timer.closed"}/>}
                                     cultureLg={theCultureLg}/>
                </div>
                <div className="prize">
                    <div className="prizeAmount"><Currency value={prizeAsset.Value}
                                                           currency={prizeAsset.Currency}
                                                           removeDecimal
                                                           className={"gold-gradient-text"}/></div>
                    <div className="name gold-gradient-text">{name}</div>
                </div>
                <div className="entryFee">
                    <FormattedMessage id={`${tr}.entryFee`} /> <Currency currency={parlay.FeeCurrency}
                                                                         value={parlay.Fee} ></Currency>
                </div>
                <button className="playButton"><FormattedMessage id={`${tr}.${isParlayStarted ? "view" : "playNow"}`} /></button>
            </div>
        </div>
    );
}

export default PreSelectedParlayCard;